"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tribunalJobReferenceCaseMap = exports.TribunalJobsFilterSchema = exports.DistraintType = exports.meetingTypes = exports.CourtMeetingState = exports.TribunalJobType = exports.InternationalTribunalJobType = void 0;
const zod_1 = __importDefault(require("zod"));
const types_1 = require("../cases/types");
const denmark_1 = require("./countries/denmark");
const greenland_1 = require("./countries/greenland");
const validation_1 = require("../../util/validation");
const insights_1 = require("../../insights");
var InternationalTribunalJobType;
(function (InternationalTribunalJobType) {
    InternationalTribunalJobType["Distraint"] = "DISTRAINT";
    InternationalTribunalJobType["CourtMeeting"] = "COURT_MEETING";
})(InternationalTribunalJobType || (exports.InternationalTribunalJobType = InternationalTribunalJobType = {}));
exports.TribunalJobType = Object.assign(Object.assign(Object.assign({}, InternationalTribunalJobType), denmark_1.DKTribunalJobType), greenland_1.GLTribunalJobType);
var CourtMeetingState;
(function (CourtMeetingState) {
    CourtMeetingState["ReadyForMeeting"] = "READY_FOR_MEETING";
    CourtMeetingState["NeedsApproval"] = "NEEDS_APPROVAL";
    CourtMeetingState["Accepted"] = "ACCEPTED";
    CourtMeetingState["Rejected"] = "REJECTED";
    CourtMeetingState["NotesSent"] = "NOTES_SENT";
    CourtMeetingState["NeedsRevision"] = "NEEDS_REVISION";
    CourtMeetingState["Concluded"] = "CONCLUDED";
    CourtMeetingState["Canceled"] = "CANCELED";
})(CourtMeetingState || (exports.CourtMeetingState = CourtMeetingState = {}));
exports.meetingTypes = [
    {
        id: 'f7cdc8f8-b15e-4394-9048-9350bc5d5107',
        label: 'Almindeligt telefonisk fogedmøde',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        meetingType: 'phone',
        relevantCaseTypes: [
            types_1.TribunalCaseType.DKBetalingspaakrav,
            types_1.TribunalCaseType.DKFogedrekvisition,
        ],
    },
    {
        id: 'f49dbe03-6d1d-4241-9d65-a33d66ba5ed6',
        label: 'Almindeligt fysisk fogedmøde',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        meetingType: 'physical',
        relevantCaseTypes: [
            types_1.TribunalCaseType.DKBetalingspaakrav,
            types_1.TribunalCaseType.DKFogedrekvisition,
        ],
    },
    {
        id: 'ef4787bb-b520-489f-a6a7-c9bf39f68ceb',
        label: 'Udkørende fogedforretning',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        meetingType: 'physical',
        relevantCaseTypes: [
            types_1.TribunalCaseType.DKBetalingspaakrav,
            types_1.TribunalCaseType.DKFogedrekvisition,
        ],
    },
    {
        id: '3ee2c615-b7c5-46e5-8ae0-6a0d1cbd419d',
        label: 'Juridisk fogedretsmøde',
        meetingType: 'phone',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        relevantCaseTypes: [
            types_1.TribunalCaseType.DKBetalingspaakrav,
            types_1.TribunalCaseType.DKFogedrekvisition,
        ],
    },
    {
        id: '1c814d89-977a-4a02-8091-66631206ca8c',
        label: 'Tvangssalg af køretøj',
        meetingType: 'physical',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        relevantCaseTypes: [types_1.TribunalCaseType.DKFogedrekvisition],
    },
    {
        id: '76e8b578-cf77-4147-b070-146580806c87',
        label: 'Tvangssalg af andelsbolig',
        meetingType: 'physical',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        relevantCaseTypes: [types_1.TribunalCaseType.DKFogedrekvisition],
    },
    {
        id: 'ba95c96d-7a92-4d16-b745-9f2976d88103',
        label: 'Tvangssalg af fast ejendom',
        meetingType: 'physical',
        tenantId: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
        relevantCaseTypes: [types_1.TribunalCaseType.DKFogedrekvisition],
    },
];
var DistraintType;
(function (DistraintType) {
    DistraintType["Property"] = "PROPERTY";
    DistraintType["Vehicle"] = "VEHICLE";
    DistraintType["RentDepositum"] = "RENTDEPOSITUM";
    DistraintType["MorgageDeed"] = "MORGAGE_DEED";
    DistraintType["CooperativeHousing"] = "COOPORATIVE_HOUSING";
    DistraintType["WithheldTax"] = "WITHHELD_TAX";
    DistraintType["Diverse"] = "DIVERSE";
})(DistraintType || (exports.DistraintType = DistraintType = {}));
exports.TribunalJobsFilterSchema = zod_1.default.object({
    types: (0, validation_1.queryJSONSchema)(zod_1.default.array(zod_1.default.nativeEnum(exports.TribunalJobType)), `type need to be a valid list of types (${Object.values(exports.TribunalJobType)})`).optional(),
    sortKey: zod_1.default.enum(['meetingDate']).optional(),
    sortDirection: zod_1.default.enum(['ASC', 'DESC']).optional(),
    jobId: zod_1.default.string().optional(),
    tribunalCaseId: zod_1.default.string().optional(),
    assignee: zod_1.default.string().uuid().optional(),
    fromDate: zod_1.default.string().date().optional(),
    toDate: zod_1.default.string().date().optional(),
    courtIds: (0, validation_1.queryJSONSchema)(zod_1.default.array(zod_1.default.string().uuid()), 'Type needs to be a list of court uuids').optional(),
    states: (0, validation_1.queryJSONSchema)(zod_1.default.array(zod_1.default.nativeEnum(CourtMeetingState)), `type need to be a valid list of types (${Object.values(CourtMeetingState)})`).optional(),
    meetingTypeIds: (0, validation_1.queryJSONSchema)(zod_1.default.array(zod_1.default.string().uuid()), `type need to be a valid list of uuids`).optional(),
    caseFilter: (0, validation_1.queryJSONSchema)(insights_1.zodCaseFilterSchema, 'type needs to be a valid case filter').optional(),
});
exports.tribunalJobReferenceCaseMap = Object.assign(Object.assign({}, denmark_1.tribunalDKJobReferenceCaseMap), greenland_1.tribunalGLJobReferenceCaseMap);
//# sourceMappingURL=types.js.map